import { useAppStateStore } from '@src/providers/AppStateProvider';
import {
  type ToastProps,
  useEndpointsContext,
  useServiceInstantiator,
  useSocketClient,
  type useToasts,
} from '@talos/kyoko';
import { ManualRFQPricingService } from './ManualRFQPricingService';

export const useManualRFQPricingService = (
  instanceID: string,
  addToast: ReturnType<typeof useToasts<ToastProps>>['add']
) => {
  const store = useAppStateStore();
  const webSocketClient = useSocketClient();
  const { orgApiEndpoint } = useEndpointsContext();

  const manualRFQPricingService = useServiceInstantiator(
    () => new ManualRFQPricingService(store, instanceID, webSocketClient, orgApiEndpoint!, addToast),
    [webSocketClient, store, instanceID, orgApiEndpoint, addToast]
  );

  return manualRFQPricingService;
};
